export default "__VITE_ASSET__DJhcEdLo__"